<template>
    <div>
       <col-skeleton-loader v-if="loading" :clms="2" :wdh="12"></col-skeleton-loader>
       <v-row width="100%" class="mt-5" v-if="!loading">
            <v-col cols="12" v-if="notes.length < 1">
               <v-card class="pa-2 green2 elevation-0">
                  <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                  <v-list class="green2">
                     <v-list-item three-line>
                        <v-list-item-content>
                           <v-list-item-subtitle>{{$t('note')}}
                              <v-tooltip top color="black">
                                 <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('animal.noteForAnimal')}}</span>
                              </v-tooltip>

                           </v-list-item-subtitle>
                           <v-list-item-title class="text-h6 mt-2">
                               {{$t('animal.noNoteFoundForThisAnimal')}}
                           </v-list-item-title>
                        </v-list-item-content>
                     </v-list-item>
                  </v-list>
               </v-card>
            </v-col>
            <v-col cols="6" v-else v-for="note in notes" :key="note.noteNumber">
               <v-card class="pa-2 green2 elevation-0">
                  <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                  <v-list class="green2">
                     <v-list-item three-line>
                        <v-list-item-content>
                           <v-list-item-subtitle>{{$t('note')}}
                              <v-tooltip top color="black">
                                 <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('animal.noteForAnimal')}}</span>
                              </v-tooltip>

                           </v-list-item-subtitle>
                           <v-list-item-title class="text-h6 mt-2">
                               {{ note.note }}
                           </v-list-item-title>
                        </v-list-item-content>
                     </v-list-item>
                  </v-list>
               </v-card>
            </v-col>
        </v-row>

    </div>
</template>
<script>
import ColSkeletonLoader from '@/components/col-skeleton-loader.vue'
import AnimalService from "@/_services/AnimalService"


export default {
    components: {
        ColSkeletonLoader,    
    },
    created() {
        const fetchData = async () => {
            this.getNotes()
        }
        fetchData();
    },
    data: () => ({
        loading:true,
        notes: [],
        
    }),
    methods: {
        getNotes() {
            this.loading = true;
            AnimalService.getNotes(this.$route.params.animal_number)
            .then( res => {
                console.log('ls',res.data.animalNotes.rows)
                this.notes = res.data.animalNotes.rows
                this.loading = false;
            })
            .catch( err => {
                console.log(err)
                this.loading = false;
            })
        }
    }
}
</script>